<template>
  <validation-observer v-slot="{ invalid }" slim>
    <div v-if="loading" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="loader"></div>
    </div>

    <div class="w-full flex justify-center bg-[#f9f8f6] pt-[48px]">
      <div class="head-container max-w-[1216px]">
        <div v-if="lead && (quote || lead.id)" class="cart-container flex justify-center 1170-bp:justify-between">
          <div class="w-full max-w-[720px]">
            <div class="w-full card">
              <div  class="mb-5 flex flex-col gap-5">
                <!-- CONTAINER SPECIFICATIONS -->
                <!-- Do not allow changes if it's shipping -->
                <p class="cart-card-title">Container Specifications</p>
                <div class="flex flex-col 1170-bp:flex-row gap-5">
                  <div class="w-full" v-if="lead.data && lead.data.useCase != 'shipping'">
                    <label class="cart-card-label">Type</label>
                    <div class="select is-fullwidth mt-1">
                      <select @change="applyFilter()" v-model="updates.purchaseType" class="custom-select">
                        <option value="rental">Renting</option>
                        <option value="sale">Buying</option>
                      </select>
                    </div>
                  </div>
                  <div class="w-full">
                    <label class="cart-card-label">Length</label>
                    <div class="select is-fullwidth mt-1">
                      <select @change="applyFilter()" v-model="updates.size" class="custom-select">
                      <option :value="value" v-for="(label, value) in availableSizes" :key="value">{{label}}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col 1170-bp:flex-row gap-5">
                  <div class="w-full" v-if="updates.purchaseType == 'sale'">
                    <label class="cart-card-label">Condition</label>
                    <div class="select is-fullwidth mt-1">
                      <select @change="applyFilter()" v-model="updates.condition" class="custom-select">
                        <option v-for="(label, value) in conditions" :value="value" :key="value">{{label}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="w-full">
                    <label class="cart-card-label">Door Config</label>
                    <div class="select is-fullwidth mt-1">
                      <select @change="applyFilter()" v-model="updates.door" class="custom-select">
                        <option :value="value" v-for="(label, value) in doorConfiguration" :key="value">{{label}}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="w-full">
                  <label class="cart-card-label">Height</label>
                  <div class="select is-fullwidth mt-1">
                    <select @change="applyFilter()" v-model="updates.height" class="custom-select">
                      <option value="any">Any</option>
                      <option value="standard">8'6</option>
                      <option value="HC">9'6</option>
                    </select>
                  </div>
                </div>
              </div>

              <section>
                <!-- QUOTE ITEMS SELECTED -->
                <article class="product-option container-item" v-for="priceBookEntry in currentPriceBooks" :key="priceBookEntry.id">
                  <product-details :price-book-entry="priceBookEntry"></product-details>
                </article>
                <p v-if="!currentPriceBooks.length" class="mt-5">
                  Currently we have no products available for the selected options - <a href="/contact">Contact Us</a>
                </p>
              </section>
            </div>

            <div v-if="(personalInfoVisible || orderInfoVisible) || (showPrice && orderInfoVisible)" :class="personalInfoVisible || orderInfoVisible ? 'mt-5' : ''">
              <div class="card checkout-form checkout-form-container">
                <personal-info-form :showPrice="showPrice" ref="personalInfoForm" v-if="personalInfoVisible || orderInfoVisible"/> 
              </div>
              <div class="card checkout-form checkout-form-container" v-if="showPrice && orderInfoVisible">
                <checkout-form ref="checkoutForm"/>
              </div>
            </div>
            <div v-if="quote && quote.items.length > 0" class="w-full max-w-[448px] 1170-bp:hidden">
              <!-- QUOTE ITEMS SUMMARY (Mobile bottom of screen)-->
              <div class="card">
                <quote-items />
                <quote-totals />
              </div>
              <!-- RECOMENDED PRODUCTS -->
              <div class="card" v-if="quote && getRecommendedProductInPricebooks(currentPriceBooks).length > 0">
                <section class="product-list recommended-products">
                  <span class="recomended-product-title mb-4">Other solutions you may like</span>
                  <div class="product-option mt-5" v-for="recommended in getRecommendedProductInPricebooks(currentPriceBooks)" :key="recommended.id">
                    <recommended-products :price-book-entry="recommended"></recommended-products>
                  </div>
                </section>
              </div>
            </div>
            <!-- BOTTOM BUTTONS -->
            <div class="button-container ">
              <div v-if="showPrice" class="flex justify-between items-center">
                <div
                  v-if="!orderInfoVisible"
                  class="is-halfwidth"
                >
                  <button
                    @click="requestQuote"
                    class="email-request-quote-btn flex justify-center items-center"
                    :class="[loading ? 'is-loading' : '', personalInfoVisible ? 'action-button' : 'close-button']"
                    :disabled="personalInfoVisible && (loading || invalid || (quote && !quote.items.length) || !quote)"
      
                  >
                    <p>{{personalInfoVisible ? 'Send Quote' : 'Email Quote'}}</p>
                  </button>
                </div>
                <div
                  v-if="!personalInfoVisible"
                  class="level-item is-halfwidth"
                >
                  <button
                      @click="reserveOrder" 
                      class="confirm-reserve-order-btn transition-all flex justify-center items-center"
                      :disabled="(loading || invalid || (quote && !quote.items.length) || !quote)"
                      :class="{ 'is-loading': loading }"
                    >
                    <p>{{orderInfoVisible ? 'Confirm Order' : 'Reserve Order'}}</p>
                  </button>
                </div>
                <div
                  v-if="personalInfoVisible || orderInfoVisible"
                  class="level-item is-halfwidth"
                >
                  <button
                      @click="cancel"
                      class="close-button email-request-quote-btn flex justify-center items-center"
                    >
                      <p>Cancel</p>
                  </button>
                </div>
              </div>
              <div v-if="!showPrice">
                <div class="level-item is-fullwidth">
                  <button
                    @click="requestQuote"
                    class="email-request-quote-btn transition-all flex justify-center items-center"
                    :disabled="loading || invalid || (quote && !quote.items.length) || !quote"
                    :class="{ 'is-loading': loading }"
                  >
                    <p>{{personalInfoVisible ? 'Email Quote' : 'Request Quote'}}</p>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="quote && quote.items.length > 0" class="w-full max-w-[448px] hidden 1170-bp:inline">
            <!-- QUOTE ITEMS SUMMARY (left side)-->
            <div class="card">
              <quote-items />
              <quote-totals />
            </div>
            <!-- RECOMENDED PRODUCTS -->
            <div class="card" v-if="quote && getRecommendedProductInPricebooks(currentPriceBooks).length > 0">
              <section class="product-list recommended-products">
                <span class="recomended-product-title mb-4">Other solutions you may like</span>
                <div class="product-option mt-5" v-for="recommended in getRecommendedProductInPricebooks(currentPriceBooks)" :key="recommended.id">
                  <recommended-products :price-book-entry="recommended"></recommended-products>
                </div>
              </section>
            </div>
          </div>

          <!-- MOBILE SUMMARY COMPONENT -->
          <div class="mobile-bottom-component" :class="{ 'is-expanded': isExpanded }">
            <div class="component-header">
              <span>Summary</span>
              <button @click="toggleExpand">
                <img src="@/images/quote-builder/drag_indicator.svg" alt="Toggle quote summary">
              </button>
            </div>
            <div class="component-content" v-if="isExpanded">
              <quote-items :hideTitle="true" />
              <quote-totals />
            </div>
          </div>

        </div>
      </div>
    </div>
    <div v-if="!lead || !lead.id" class="w-full flex justify-center items-center bg-[#f9f8f6] pb-[64px] font-rubik"> 
      <div class="empty-cart-container w-full flex flex-col gap-10 justify-center items-center max-w-[1216px] border-none lg:border-[#EDE9E3] lg:rounded-2xl lg:border lg:bg-[#EDE9E3] lg:h-[280px] pb-[48px] lg:pb-0">
        <p class="empty-cart-container-p">Your cart is empty</p>
        <button @click="browseProducts()" class="empty-cart-container-btn">
          <p>Browse products</p>
        </button>
      </div> 
    </div> 
    <div v-if="thankYouModalVisible">
      <thanks :closeModal="closeModal" :type="actionType" :closedQuote="closedQuote" :paymentLink="paymentLink"/>
    </div>
  </validation-observer>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Step from '../flow/steps/mixin'
import ProductDetails from '../flow/steps/helpers/product-details.vue'
import QuoteItems from '../flow/steps/helpers/items.vue'
import QuoteTotals from '../summary/totals.vue'
import RecommendedProducts from '../flow/steps/helpers/recommended-products.vue'
import CheckoutForm from './helpers/checkout-form.vue'
import PersonalInfoForm from './helpers/personal-info-form.vue'
import { ValidationObserver } from 'vee-validate'
import Thanks from './helpers/thanks.vue'
import ahoy from 'shared/ahoy'
import { zipQuery, citySearchQuery, solutionByCity } from 'shared/graphql/queries'
import { graphqlQuery } from 'shared/graphql'
import { cityPath } from '../../../shared/city-helper'
import { invoiceOrderMutation } from 'shared/graphql/mutations'

const ZIP_REGEX = /^\d{5}$/
const redirectToCity = (city) => window.location.href = cityPath(city)

export default {
  components: {
    ProductDetails,
    QuoteItems,
    QuoteTotals,
    RecommendedProducts,
    CheckoutForm,
    ValidationObserver,
    Thanks,
    PersonalInfoForm
  },
  mixins: [ Step ],
  props: {
    token: {
      type: String,
      required: false,
      default: ''
    }
  },
  async mounted () {
    if (this.token) {
      const quote = await this.$store.dispatch('quote/quote.session.init', { token: this.token })
      await this.$store.dispatch('quote/pricing.load')
      if (quote && quote.opportunity && quote.opportunity.closed) {
        this.$store.commit('quote/reset')
        this.$store.commit('quote/flow/step.set', this.steps.indexOf('start'))
      } else if (quote && quote.status == 'draft') {
        window.location.href = '/cart'
      }
    }
  },
  async created () {
    await this['pricing.get']()
    
    if (!this.lead) {
      return
    }

    const { purchaseType, size, useCase, condition, door, height } = this.lead.data
    let currentCondition = condition 
    if (!currentCondition) {
      currentCondition = purchaseType == 'rental' ? 'used' : 'one_trip'
    }
    this.updates = {
      ...this.updates,
      purchaseType, 
      size, 
      useCase,
      door: door || 'any',
      height: height || 'any',
      condition: currentCondition
    }
    if (this.quote && this.quote.items.length > 0) {
      if (!this.updates.purchaseType) {
        this.updates.purchaseType = this.quote.items[0].priceBookEntry.product.rentalType == 'none' ? 'sale' : 'rental'
      }
      if (!this.updates.size) {
        this.updates.size = this.quote.items[0].priceBookEntry.product.size
      }
      if (!this.updates.condition) {           
        this.updates.condition = this.quote.items[0].priceBookEntry.product.condition
      }
    }
    this.$store.dispatch('quote/flow/options.compute')
    this.applyFilter()
  },
  data() {
    return {
      orderId: null,
      paymentLink: null,
      priceBooks: null,
      personalInfoVisible: false,
      orderInfoVisible: false,
      doorConfiguration: {
        any: 'Any',
        cargo_door: 'Cargo Door',
        double_door: 'Double Door',
        open_side: 'Open Side',
        open_top: 'Open Top',
        soft_top: 'Soft Top',
        hard_top: 'Hard Top',
        roll_door: 'Roll Door',
        flat_rack: 'Flat Rack',
        working_refrigerated: 'Working Refrigerated',
        non_working_refrigerated: 'Non Working Refrigerated',
        other: 'Other'
      },    
      shippingConditions: [
        'one_trip',
        'iicl',
        'cargo_worthy'
      ],
      conditions: {
        'one_trip': 'One Trip',
        'refurbished': 'Refurbished',
        'cargo_worthy': 'Cargo Worthy',
        'wind_water_tight': 'Wind & Water Tight'   
      },
      loading: false,
      thankYouModalVisible: false,
      actionType: '',
      closedQuote: {},
      isExpanded: false,

      solutionSlug: 'sale',
      error: null,
      query: '',
      coordinates: null,
      cities: []
    }
  },
  computed: {
    ...mapState('quote', [  'priceBook', 'quote', 'lead', 'errors' ]),
    ...mapState('quote/flow', [ 'priceBookEntries', 'options', 'gtagEvent', 'originalPriceBookEntries' ]),
    ...mapGetters('quote/flow', [ 'steps', 'stepComponent', 'isComplete' ]),
    ...mapGetters('cookies', ['allCookiesAccepted', 'isSet']),
    ...mapState('shared', ['zipcode']),
    showPrice() {
      if (this.priceBook && this.priceBook.priceVisibility == 'private') {
        return false
      } else if (this.quote) {
        return this.quote.items.filter(item => item.priceBookEntry.priceVisibility == 'private').length == 0
      }
      return true
    },
    availableSizes() {
      const sizes = {
        '10': '10ft',
        '20': '20ft',
        '40': '40ft',
        '45': '45ft'
      }
      const { useCase } = this.lead.data
      if (useCase) {
        switch (useCase) {
        case 'storage':
          return sizes
        case 'shipping':
          delete sizes['10']
          return sizes
        default:
          delete sizes['10']
          delete sizes['45']
          return sizes
        }
      }
      return sizes
    },
    currentPriceBooks: {
      get() {
        return this.priceBooks !== null ? this.priceBooks : this.priceBookEntries
      },
      set(newValue) {
        this.priceBooks = [...newValue]
      }
    }
  },
  methods: {
    async generateInvoiceFromOrder(orderId) {
      try {
        const organization = this.$store.state.shared.organization
        const response = await graphqlQuery({
          headers: { 'organization-id': organization.id },
          query: invoiceOrderMutation,
          variables: { id: orderId, webSite: true }
        })

        this.paymentLink = 
        response?.data?.invoiceOrder?.order?.paymentLink 
        || null

      } catch (e) {
        console.error('Failed to generate invoice:', e)
      }
    },
    ...mapActions('quote', ['pricing.get']),
    ...mapState('cookies', ['analytics']),
    async save () {
      const { lead, updates } = this
      ahoy.track('lead.update', updates)
      lead.data = { ...lead.data, ...updates }
      return await this.$store.dispatch('quote/lead.save', lead)
    },
    cancel() {
      this.personalInfoVisible = false
      this.orderInfoVisible = false
    },
    filterOptions(items, option, value) {
      return items.filter(i => i.product[option] && i.product[option] === value)
    },
    async applyFilter() {
      const { purchaseType, size, useCase, condition, height } = this.lead.data
      let priceBooks = [...this.originalPriceBookEntries]
      let selectedPurchaseType = this.updates.purchaseType || purchaseType
      let selectedSize = this.updates.size || size
      let selectedCondition = this.updates.condition || condition
      let doorConfiguration = this.updates.door || ''
      let selectedHeight = this.updates.height || height
      let classification = selectedPurchaseType === 'sale' ? 'container' : 'container_rental'
      if (selectedPurchaseType == 'rental') {
        selectedCondition = 'other'
      } else {
        selectedCondition = this.updates.condition || 'one_trip'
      }
      priceBooks = priceBooks.filter(i => i.product.classification === classification)
      priceBooks = priceBooks.filter(i => i.product.size && i.product.size !== 'ODD' && i.product.size.replace(/\D/g,'') == selectedSize)
      if (selectedCondition) {
        priceBooks = priceBooks.filter(i => {
          return i.product.condition == selectedCondition
        })
      }
      if (doorConfiguration != 'working_refrigerated' && doorConfiguration != 'non_working_refrigerated') {
        switch (useCase) {
        case 'coldStorage':
          priceBooks = this.filterOptions(priceBooks, 'config', 'working_refrigerated')
          break
        case 'insulatedStorage':
          priceBooks =  this.filterOptions(priceBooks, 'config', 'non_working_refrigerated')
          break
        case 'shipping':
          priceBooks = priceBooks.filter(i => this.shippingConditions.includes(i.product.condition))
          break
        case 'storage':
          priceBooks = priceBooks.filter(i => i.product.config && i.product.config != 'working_refrigerated' && i.product.config != 'non_working_refrigerated')
          break
        }
      } else if (doorConfiguration == 'working_refrigerated') {
        priceBooks = this.filterOptions(priceBooks, 'config', 'working_refrigerated')
      } else if (doorConfiguration != 'non_working_refrigerated') {
        priceBooks =  this.filterOptions(priceBooks, 'config', 'non_working_refrigerated')
      }
      if (doorConfiguration && doorConfiguration != 'any') {   
        priceBooks = this.filterOptions(priceBooks, 'config', doorConfiguration)         
      }
      if (selectedHeight && selectedHeight != 'any') {  
        priceBooks = priceBooks.filter(i => {
          if (i.product.size.includes('HC') && selectedHeight == 'HC') {
            return i
          } else if (!i.product.size.includes('HC') && selectedHeight != 'HC') {
            return i
          } else {
            return false
          }
        })        
      }
      this.currentPriceBooks = priceBooks
    },
    getRecommendedProductInPricebooks(currentPriceBooks) {
      let recommended = []
      const alreadyOnReccomended = []
      const productsOnFilteredPriceBook = currentPriceBooks.map(item => item.product.id)

      this.quote.items.forEach(item => {
        const recommendedIds = item.priceBookEntry.product.recommendedProducts.map(recommendedProduct => recommendedProduct.relatedProduct.id)
        recommended = recommended.concat(this.originalPriceBookEntries.filter(priceBook => {          
          if (recommendedIds.includes(priceBook.product.id) && 
            productsOnFilteredPriceBook.includes(item.priceBookEntry.product.id) && 
            !alreadyOnReccomended.includes(priceBook.product.id) && 
            !productsOnFilteredPriceBook.includes(priceBook.product.id)
          ) {
            alreadyOnReccomended.push(priceBook.product.id)
            return true
          }
          return false
        }))
      })
      return recommended
    },
    async reserveOrder() {
      if (!this.orderInfoVisible) {
        this.orderInfoVisible = true
        return
      }
      if (this.loading) return
      this.loading = true
      const personalInfo = await this.$refs.personalInfoForm.save()
      if (personalInfo && personalInfo.errors && personalInfo.errors.length) {
        console.warn(personalInfo.errors)
        this.loading = false
      } else {
        const checkout = await this.$refs.checkoutForm.save()
        if (checkout && checkout.errors && checkout.errors.length) {
          console.warn(checkout.errors)
          this.loading = false
        } else {
          this.closedQuote = this.quote
          this.sendQuoteEmail()

          const updatedOpportunity = await this.closeOpportunity()

          if (updatedOpportunity?.order?.id) {
            await new Promise(resolve => setTimeout(resolve, 9000))
            await this.generateInvoiceFromOrder(updatedOpportunity.order.id)
          }
                   
          this.$store.dispatch('quote/opportunity.save', {
            eventName: 'email.order',
            input: {
              quoteId: this.quote.id
            }
          })
  
          this.$store.commit('quote/reset')
          this.$store.commit('quote/flow/reset')
          this.thankYouModalVisible = !this.thankYouModalVisible
          this.actionType = this.thankYouModalVisible ? 'reservation' : ''
          window.scrollTo(0, 0)
          this.orderInfoVisible = false
          this.loading = false
        }
      }
    },

    closeOpportunity() {
      return this.$store.dispatch('quote/opportunity.save', {
        eventName: 'close',
        input: {
          quoteId: this.quote.id,
          status: 'closed_won',
          paymentMethod: 'credit_card'
        }
      })
    },
    closeModal() {
      this.thankYouModalVisible = false
    },
    async requestQuote() {
      if (!this.personalInfoVisible) {
        this.personalInfoVisible = true
        return
      }
      if (this.loading) return
      this.loading = true
      const result = await this.$refs.personalInfoForm.save()
      if (result && result.errors && result.errors.length) {
        console.warn(result.errors)
      } else {
        this.closedQuote = this.quote
        this.sendQuoteEmail()
        this.$store.commit('quote/reset')
        this.$store.commit('quote/flow/reset')
        this.thankYouModalVisible = true
        this.actionType = this.thankYouModalVisible ? 'email' : ''
        window.scrollTo(0,0)
      }
      if (this.analytics === true && window.gtag) {
        window.gtag('event', this.gtagEvent)
        window.gtag('event', 'conversion', {'send_to': 'AW-1039884839/0NUSCPGWqawYEKfE7e8D'})
      }
      this.loading = false
      this.personalInfoVisible = false
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },
    async browseProducts() {
      if (!this.allCookiesAccepted) {
        window.location.href = '/solutions/container-sales'
      } else if (this.allCookiesAccepted) {
        const zipcode = this.lead && this.lead.data && this.lead.data.zipcode ? this.lead.data.zipcode : this.zipcode
        if (!zipcode) {
          console.warn('No existing zipcode found.')
          return
        }
        await this.search(zipcode)
      }
    },

    async search(zipcode) {
      this.cities = []
      this.loading++
      this.query = zipcode
      this.lastQuery = zipcode
      try {
        this.trackSearch()
        const result = await graphqlQuery(this.getRequestBody())
        if (result.data.zipcode) {
          const aboutSlug = `/service-areas/${result.data.zipcode.city.id}/`
          localStorage.setItem('serviceAreaAboutSlug', JSON.stringify(aboutSlug)) 
        } 
        return this.handleResult(result.data || {})
      } catch (e) {
        console.warn(e)
        this.error = 'There was an error while searching.'
        this.loading = 0
      }
    },

    async trackSearch() {
      ahoy.track('location.search', {
        coordinates: this.coordinates,
        query: this.query
      })
    },
    getRequestBody() {
      if (ZIP_REGEX.test(this.query)) {
        return {
          query: zipQuery,
          variables: {
            id: this.query
          }
        }
      } else {
        return {
          query: citySearchQuery,
          variables: {
            query: this.query
          }
        }
      }
    },
    async handleResult(result) {
      let { zipcode, zipcodes, cities } = result
      if (!zipcode && zipcodes && zipcodes.edges.length === 1) {
        zipcode = zipcodes.edges[0].node
      }
      
      if (this.solutionSlug && zipcode) {        
        const data = await this.getSolutionPage(zipcode)
        
        if (data && data.solutionByCity && data.solutionByCity.solution) {
          if (this.lead) {
            await this.$store.dispatch('quote/lead.zipcode.update', {lead: this.lead, zipcode: zipcode.id})
          } else {
            this.$store.commit('shared/zipcode.set', zipcode.id)
          }
          this.$emit('close')
          this.loading = 0
          window.location.href = `/partners/${data.solutionByCity.organization.id}/${data.solutionByCity.solution.slug}`
          return
        }
      }
      if (zipcode) {
        if (this.lead) {
          await this.$store.dispatch('quote/lead.zipcode.update', {lead: this.lead, zipcode: zipcode.id})
        } else {
          this.$store.commit('shared/zipcode.set', zipcode.id)
        }
        this.$emit('close')
        return redirectToCity(zipcode.city)
      }
      else if (cities && cities.edges.length) {
        if (cities.edges.length === 1) {
          this.$emit('close')
          return redirectToCity(cities.edges[0].node)
        } else {
          this.cities = cities.edges
        }
      }
      else {
        this.error = 'Sorry, we couldn\'t find that location.'
      }
      this.loading = 0
    },
    async getSolutionPage(zipcode) {
      const body = {
        query: solutionByCity,
        variables: {
          cityId: zipcode.city.id,
          solutionSlug: this.solutionSlug
        }
      }
      const result = await graphqlQuery(body)
      return result.data
    },
    async sendQuoteEmail() {
      this.$store.dispatch('quote/opportunity.save', {
        eventName: 'email.quote',
        input: {
          quoteId: this.closedQuote.id,
          status: 'quoted',
          paymentMethod: 'credit_card'
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .header-banner {
    width:100%;
    @media (max-width: 520px) {
      height: 90px;
    } 
  }
  .header-title {
    position: absolute; 
    top: 2.5rem; 
    color: white; 
    left: 10%;

    h1 {
      font-size: 2rem;
      font-weight: 600;
      text-shadow: 4px 4px 10px black;
    }

    h2 {
      text-shadow: 4px 4px 10px black;
      font-size: 1.125rem;
      font-weight: 600;
    }
    @media (max-width: 868px) {    
        top: 1.5rem;  
        h1 {
          font-size: 2rem;
        }    
    }
    @media (max-width: 768px) {    
        top: 1rem;  
        h1 {
          font-size: 1.375rem;
        }
        h2 {
          font-size: 0.875rem;
        }
    }
  } 
</style>

<style scoped lang="scss">
  .head-container {
    width: 100%;
    padding-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 874px) {
      padding: 0 0 4.125rem 0rem;
    }
  }
  .cart-container {
    width: 100%;
    padding: 0px 12px;

    .left-content {
      flex: 720 1 0%;
      max-width: 720px;
    }
    .right-content {
      flex: 448 1 0%;
      max-width: 448px;
    }
    .is-fullwidth {
      width: 100%;
    }
    .neutral-gray {
      color: #767676;
    }
    .product-option { 
      border: 1px solid #EDE9E3;
      border-radius: 10px;
      background: #F9F8F6;
      padding: 1rem;
      margin-top: 1.5rem;
    }
    .card {
      width: 100%;
      padding: 25px;
      background: #fff;
      margin-bottom: 1.75rem;
      border-radius: 12px;
      border: 1px solid #EDE9E3;
      box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
      .summary-wrapper.checkout-form {
        padding-top: 0;
      }
    }
    .card-gray {
      // Request quote bottom button
      background: #EDEFF7;
      padding: 1.375rem;
      .product-option {
        border: unset;
        padding: 0;
        .recommended-product {
          border-radius: 2px;
        }
      }
    }

    @media (min-width: 1170px) {
      padding: 0px;
    }
  }

  .cart-empty {
    padding: 5rem;
    color: #061627;
  }

  .cart-card-title {
    font-size: 24px;
    font-weight: 400;
    line-height: 28.8px;
    letter-spacing: -0.04em;
    color: #334155;
  }

  .cart-card-label {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.0125em;
    color: #000000;
  }

  select.custom-select {
    flex: 1;
    border: 1px solid #E0DAD1;
    outline: none;
    border-radius: 12px;
    height: 48px;
    padding-right: 1rem;
    padding-left: 1rem;
    background-color: #F9F8F6;

    color: #334155;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.0125em;

    &:focus,
    &[type="email"]:focus,
    &[type="number"]:focus,
    &[type="search"]:focus,
    &[type="text"]:focus,
    &[type="tel"]:focus,
    &[type="url"]:focus,
    &[type="password"]:focus {
      border: 0;
      color: #000;
      box-shadow: inset 0 1px 5px 0px rgba(0, 0, 0, 0.02);
    }
  }

  .recomended-product-title {
    font-size: 24px;
    font-weight: 400;
    line-height: 28.8px;
    letter-spacing: -0.04em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #334155;
  }

  .mobile-bottom-component {
    border: 1px solid #E0DAD1;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 82px;
    background-color: #fff;
    z-index: 1000;
    transition: height 0.3s ease;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);

    .component-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      height: 82px;

      span {
        font-size: 24px;
        font-weight: 400;
        line-height: 33.6px;
        letter-spacing: -0.04em;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: #334155;
      }

      button {
        background: none;
        border: none;
        font-size: 16px;
        color: #007bff;
      }
    }

    .component-content { 
      overflow-y: auto;
      height: 428px;
      padding: 0 16px;
    }

    &.is-expanded {
      height: 528px;
    }

    @media (min-width: 1170px) {
      display: none;
    }
  }

  .button-container {
    background: #F9F8F6 !important;
    width: 100%;
    margin-bottom: 1.75rem;
    border-radius: 12px;
  }
  
  .email-request-quote-btn {
    width: 100%;
    height: 44px;
    border-radius: 999px;
    border: 1px solid #90B6FF;
    background-color: transparent;
    &:disabled {
      cursor: not-allowed;
    }
  }
  
  .email-request-quote-btn p {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.04em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #3565FC !important;
  }

  .confirm-reserve-order-btn {
    width: 100%;
    height: 44px;
    border-radius: 999px;
    border: 1px solid #90B6FF;
    background-color: #3565FC;
    transition: background-color 0.3s ease;

    &:hover:not(:disabled) {
      background-color: #1f44f1 !important;
    }

    &:disabled {
      cursor: not-allowed;
      background-color: #3e5eed;
      border-color: #90B6FF;
    }

    &:disabled:hover {
      background-color: #1f44f1 !important;
    }

    p {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.04em;
      text-align: center;
      color: #FFFFFF;
      margin: 0;
    }

    &:disabled p {
      color: #FFFFFF;
    }
  }

  .empty-cart-container-p {
    font-size: 24px;
    font-weight: 400;
    line-height: 28.8px;
    letter-spacing: -0.04em;
    color: #334155;
  }

  .empty-cart-container-btn {
    width: 352px;
    height: 44px;
    background-color: #3565FC;
    border: 1px solid #90B6FF;
    border-radius: 99px;
  }

  .empty-cart-container-btn p {
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.04em;
  }

  /* Mobile */
  @media (max-width: 1024px) {
    .empty-cart-container-btn {
      width: 271px;
    }
  }

  .loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #555;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

</style>
